export const fromMicroAlgo = (amount) => amount / 1000000;
export const toMicroAlgo = (amount) => amount * 1000000;
